import styled from 'styled-components/macro'
import Typography from '@mui/material/Typography'

export const HelpPageContainer = styled.div`
  /* Override Dashboard's left padding */
  margin-left: -60px;
  /* Account for full width including drawer */
  width: calc(100vw - 280px - 60px);

  /* Center the content */
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 70vh;
  background: transparent;

  /* Make it responsive */
  @media (max-width: 768px) {
    width: 100vw;
  }
`

export const HelpCard = styled.div`
  background: white;
  border-radius: 24px;
  box-shadow: 0px 4px 20px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 600px;
  padding: 40px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  border: 1px solid rgba(0, 0, 0, 0.1);
`

export const HelpForm = styled.form`
  width: 100%;
  max-width: 500px;
`

export const HeaderTypography = styled(Typography)`
  && {
    color: ${(props) => props.theme.palette.text.primary};
    text-align: center;
  }
`
